var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeedMasterGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "48px",
    viewBox: "0 0 45 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rewards/speed-master-gold") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.0053372093 6.95652174e-05 44.6563953 6.95652174e-05 44.6563953 48 0.0053372093 48"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.0053372093 6.95652174e-05 44.6563953 6.95652174e-05 44.6563953 44.5218087 0.0053372093 44.5218087"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0.0053372093 6.95652174e-05 44.6563953 6.95652174e-05 44.6563953 44.5218087 0.0053372093 44.5218087"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Product",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-Rewards-1440",
    transform: "translate(-1006.000000, -393.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rewards/speed-master-gold",
    transform: "translate(1006.000000, 393.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3309186,48.0000696 L22.3309186,48.0000696 C10.0009186,48.0000696 0.0053372093,38.0334609 0.0053372093,25.7392 L0.0053372093,4.17398261 C0.0053372093,1.86893913 1.87963953,6.95652174e-05 4.19138372,6.95652174e-05 L40.4704535,6.95652174e-05 C42.7821977,6.95652174e-05 44.6565,1.86893913 44.6565,4.17398261 L44.6565,25.7392 C44.6565,38.0334609 34.6609186,48.0000696 22.3309186,48.0000696",
    id: "Fill-1",
    fill: "#AD8D07",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3309186,44.5218087 L22.3309186,44.5218087 C10.0009186,44.5218087 0.0053372093,34.5552 0.0053372093,22.2609391 L0.0053372093,4.17398261 C0.0053372093,1.86893913 1.87963953,6.95652174e-05 4.19138372,6.95652174e-05 L40.4704535,6.95652174e-05 C42.7821977,6.95652174e-05 44.6565,1.86893913 44.6565,4.17398261 L44.6565,22.2609391 C44.6565,34.5552 34.6609186,44.5218087 22.3309186,44.5218087",
    id: "Fill-4",
    fill: "#FFDC4A",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4704535,6.95652174e-05 L4.19138372,6.95652174e-05 C1.87963953,6.95652174e-05 0.0053372093,1.86893913 0.0053372093,4.17398261 L0.0053372093,22.2609391 C0.0053372093,34.5552 10.0009186,44.5218087 22.3309186,44.5218087 C34.6609186,44.5218087 44.6565,34.5552 44.6565,22.2609391 L44.6565,4.17398261 C44.6565,1.86893913 42.7821977,6.95652174e-05 40.4704535,6.95652174e-05 M40.4704535,4.17398261 L40.4704535,22.2609391 C40.4704535,32.2341565 32.3331279,40.3478957 22.3309186,40.3478957 C12.3287093,40.3478957 4.19138372,32.2341565 4.19138372,22.2609391 L4.19138372,4.17398261 L40.4704535,4.17398261",
    id: "Fill-7",
    fill: "#D3AB05",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.859186,9.96932174 L15.859186,23.2465391 C15.859186,23.6305391 16.1717442,23.9421913 16.5568605,23.9421913 L19.1734884,23.9421913 C19.5589535,23.9421913 19.8711628,24.2534957 19.8711628,24.6378435 L19.8711628,33.3703652 C19.8711628,34.0806261 20.8126744,34.3345391 21.1716279,33.7209739 L28.6206977,20.9877565 C28.892093,20.5241043 28.5565116,19.9414957 28.0182558,19.9414957 L25.0123256,19.9414957 C24.4936047,19.9414957 24.1562791,19.3974957 24.3882558,18.934887 L28.7281395,10.2806261 C28.9601163,9.81801739 28.6227907,9.27366957 28.1040698,9.27366957 L16.5568605,9.27366957 C16.1717442,9.27366957 15.859186,9.58532174 15.859186,9.96932174",
    id: "Fill-28",
    fill: "#AD8D07"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedMasterGold);
export default __webpack_public_path__ + "static/media/speed-master-gold.9b86d6145a06a9a411f37421b568e8c2.svg";
export { ForwardRef as ReactComponent };